import { FC, useCallback } from "react";
import { Stack, Typography } from "@mui/material";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../store/hooks";
import { filterTemplatesLoadingByAccountIdSelector } from "../../../../../../../store/filters/selectors/filter-set/filterTemplatesLoadingByAccountIdSelector";
import { filterTemplatesByAccountIdSelector } from "../../../../../../../store/filters/selectors/filter-set/filterTemplatesByAccountIdSelector";
import { FilterTemplateDropDownContent } from "../../../../../account/components/filter-templates/templates-dropdown/FilterTemplateDropDownContent";
import { applyFilterTemplateToAccountsThunk } from "../../../../../../../store/filters/thunks/filter-set/applyFilterTemplateToAccountsThunk";
import { getAccountsThunk } from "../../../../../../../store/accounts/thunks/getAccountsThunk";
import { ProviderType } from "../../../../../../../services/cloudchipr.api";
interface AccountCardFilterTemplatePopoverContentProps {
  accountId: string;
  onClose(): void;
  provider: ProviderType;
  filterSetId: string | null;
}

export const AccountCardFilterTemplatePopoverContent: FC<
  AccountCardFilterTemplatePopoverContentProps
> = ({ accountId, onClose, filterSetId, provider }) => {
  const dispatch = useAppDispatch();

  const onClick = useCallback((event: any) => {
    event.preventDefault();
  }, []);

  const loading = useAppSelector((state) =>
    filterTemplatesLoadingByAccountIdSelector(state, accountId),
  );

  const filterTemplates = useAppSelector((state) =>
    filterTemplatesByAccountIdSelector(state, {
      accountId,
    }),
  );

  const applyClickHandler = useCallback(
    async (filterSetId: string) => {
      await dispatch(
        applyFilterTemplateToAccountsThunk({
          filterSetId,
          accountIds: [accountId],
        }),
      );
      dispatch(getAccountsThunk());
      onClose();
    },
    [dispatch, accountId, onClose],
  );

  return (
    <Stack onClick={onClick}>
      <FilterTemplateDropDownContent
        onApplyFilterTemplate={applyClickHandler}
        appliedFilterSetId={filterSetId ?? ""}
        provider={provider}
        filterTemplates={filterTemplates}
        loading={loading}
        header={
          <Typography variant="subtitle2" px={2} py={1}>
            Filter Templates
          </Typography>
        }
      />
    </Stack>
  );
};
